// @flow
import * as types from './mutation-types'
import type { CompanyState } from './index'
import type { Company } from '../../../types/company'
import type { ValidationErrorResult } from '../../../types/validation-error-result'
import type {PrimaryAddress} from '../../../types/primary-address'
import type {VisitAddress} from '../../../types/visit-address'
import type {PostAddress} from '../../../types/post-address'
import type {CompanySelfServiceStatus} from '../../../types/company-self-service-status'

export default {
  [types.SET_COMPANY]: (state: CompanyState, payload: Company): void => {
    state.company = payload
  },

  [types.SET_VALIDATION_ERRORS]: (state: CompanyState, error: ValidationErrorResult): void => {
    state.companyValidationErrors = error.validationErrors
  },

  [types.SET_COMPANY_CONTACT_DETAILS]: (state: CompanyState, payload: Company): void => {
    state.company.organisationName = payload.organisationName
    state.company.kvkNumber = payload.kvkNumber
    state.company.accountNumber = payload.accountNumber
    state.company.firstName = payload.firstName
    state.company.surnamePrefix = payload.surnamePrefix
    state.company.surname = payload.surname
    state.company.gender = payload.gender
    state.company.department = payload.department
    state.company.function = payload.function
    state.company.gender = payload.gender
    state.company.phoneNumber = payload.phoneNumber
    state.company.phoneNumber2 = payload.phoneNumber2
    state.company.emailAddress = payload.emailAddress
  },

  [types.SET_COMPANY_ADDRESSES]: (state: CompanyState, payload: Object): void => {
    state.company.postAddress = payload.postAddress
    state.company.visitAddress = payload.visitAddress
    state.company.primaryAddress = payload.primaryAddress
  },

  [types.SET_PRIMARY_ADDRESS]: (state: CompanyState, primaryAddress: PrimaryAddress): void => {
    state.company.primaryAddress = primaryAddress
  },

  [types.SET_VISIT_ADDRESS]: (state: CompanyState, visitAddress: VisitAddress): void => {
    state.company.visitAddress = visitAddress
  },

  [types.SET_POST_ADDRESS]: (state: CompanyState, postAddress: PostAddress): void => {
    state.company.postAddress = postAddress
  },

  [types.SET_SELF_SERVICE_STATUS]: (state: CompanyState, companySelfServiceStatus: CompanySelfServiceStatus): void => {
    state.selfServiceStatus = companySelfServiceStatus
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company/mutations.js